/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import * as AddressService from './service'
import { AddressPath, IProvince } from './model'
import { sortingThAddress } from 'helpers/sortingThAddress'

export const findAll = async (params?: any): Promise<{ body: IProvince[] }> => {
  const response = await AddressService.findAll(AddressPath.PROVINCES, params)

  sortingThAddress(response.body)

  return response as { body: IProvince[] }
}
